import { render, staticRenderFns } from "./generator.camera.screenshot.vue?vue&type=template&id=96d05846&"
import script from "./generator.camera.screenshot.vue?vue&type=script&lang=ts&"
export * from "./generator.camera.screenshot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports